<div class="h-full overflow-y-auto">
  <app-sidebar-item
    class="rounded hover:bg-hover"
    *dndNestedFor="
      let item of items();
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let expanded = expanded;
      stateKey: 'settings-sidebar';
      dropDisabled: true
    "
    [title]="item.title"
    [icon]="item.icon"
    [depth]="depth"
    [expandable]="expandable"
    [expanded]="expanded.value"
    [active]="isItemActive(item)"
    (onExpand)="expanded.next($event)"
    (appClick)="selectFilter(item, expandable, expanded)"
    [iconSlot]="depth === 0 ? 'icon' : 'reserved'"
  />
</div>
